<template>
    <div class="works-content">
        
        <div class="works-item" v-for="(item, index) in list" :key="index">
            <img class="works-img listWOW fadeInDown"
                data-wow-duration="0.4s"
                data-wow-delay="0.5s" 
                :src="item.pictures" 
                @click="picturesClick(index)" alt="">
            <div 
                class="works-info listWOW fadeInDown"
                data-wow-duration="0.6s"
                data-wow-delay="0.5s"
            >
                <div class="txt" v-html="item.info"></div>
            </div>
        </div>
        
        <!-- <van-icon v-show="show" @click="arrowClick('-')" name="arrow-left" /> -->
        <van-image-preview ref="preview" :startPosition="startPosition" v-model="show" :images="imagePreviewList" @change="onChange">
            <template v-slot:index>{{ index + 1}}/{{imagePreviewList.length}}</template>
        </van-image-preview>
        <!-- <van-icon v-show="show" @click="arrowClick('+')" name="arrow" /> -->
    </div>
</template>
<script>
    import { findWords, workYearsMobile } from '../../api'
    import { ImagePreview } from 'vant';
    export default{
        props:{

        },
        data(){
            return {
                list:[],
                imagePreviewList: [],
                index: 0,
                startPosition: 0,
                show: false,
                yearItem: '',
                page: 1
            }
        },
        created(){
            if (this.$route.query.year) {
                var query = this.$route.query.year
                this.yearItem = query
            }
            this.findWords()
        },
        watch:{
            '$route.query': {
                handler(val){
                    if (val.year) {
                        var query = val.year
                        this.yearItem = query
                    }
                    this.findWords()
                },
                deep: true
            }
        },
        methods:{
            findWords() {
                findWords({
                    page: 1,
                    limit: 100,
                    years: this.yearItem,
                    equipment: 0
                }).then(res=>{
                    var data = res.data.data.records
                    var imagePreviewList = []
                    for (var item of data) {
                        imagePreviewList.push(item.pictures)
                    }
                    this.imagePreviewList = imagePreviewList
                    this.list = res.data.data.records
                    this.$nextTick(()=>{
                        this.$wow('listWOW')
                    })
                })
            },

            arrowClick(type) {
                if (type=='+') {
                    this.index==this.imagePreviewList.length?this.$refs.preview.swipeTo(0):this.$refs.preview.swipeTo(this.index+1)
                    
                } else {
                    this.index==1?this.$refs.preview.swipeTo(this.imagePreviewList.length):this.$refs.preview.swipeTo(this.index-1)

                }
            },
            onChange(e) {
                this.index = e
            },
            picturesClick(index){
                // this.index = index + 1
                // this.show = true
                
                var ua = navigator.userAgent,
                isWindowsPhone = /(?:Windows Phone)/.test(ua),
                isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
                isAndroid = /(?:Android)/.test(ua),
                isFireFox = /(?:Firefox)/.test(ua),
                isChrome = /(?:Chrome|CriOS)/.test(ua),
                isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
                isPhone = /(?:iPhone)/.test(ua) && !isTablet,
                isPc = !isPhone && !isAndroid && !isSymbian;
                console.log(isTablet);
                if (isTablet) {
                    ImagePreview({
                        images: this.imagePreviewList,
                        startPosition: index,
                    })
                } else {
                    this.show = true
                    this.index = index
                    this.startPosition = index
                    // setTimeout(()=>{
                    //   this.$refs.preview.swipeTo(index)
                    // },10)
                    // const $viewer = viewerApi({
                    //   options: {
                    //     toolbar: true,
                    //     initialViewIndex: index
                    //   },
                    //   images: this.imagePreviewList
                    // })
                }
                
            }
        }
    }
</script>
<style scoped>
    .txt>>>*{
        font-size: .2rem!important;
        font-family: KhmerSangamMN!important;
        font-weight: 400;
        /* font-style: italic; */
        line-height: 1.2;
        color: #000000;
    }
    .works-content{
        padding-top:.4rem;
    }
    .works-item{
        display:flex;
        flex-direction: column;
        align-items: center;
    }
    .works-item+.works-item{
        margin-top:.7rem;
    }
    .works-img{
        max-width:7.1rem;
        max-height:7.5rem;
        object-fit: cover;
        margin:0 auto;
    }
    .works-info{
        margin-top:.2rem;
    }
</style>